import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, createSlots as _createSlots, createBlock as _createBlock, Fragment as _Fragment } from "vue"

const _hoisted_1 = { key: 0 }

import { onMounted, ref } from 'vue';

/********************************
 ********** COMPONENTES *********
 *******************************/
import ResetDialog from '@/components/SmartLink/dialog/ResetDialog.vue';

/********************************
 ************ STORE *************
 *******************************/
import { useStore }         from 'vuex';
import { useI18n } from 'vue-i18n';
import { getClientStatusData } from '@/services/Smartlink/Reset';

/********************************
 *********** FUNCTION ***********
 *******************************/
import { getColorStatus } from '@/functions/project'

/********************************
 ********** CONSTANTES **********
 *******************************/
import { LABELS } from '@/constants/labels';
import { RESET_HEADER } from '@/constants/tableHeaders'

/********************************
 ********** INTERFACES **********
 *******************************/
import { HEADER } from '@/interfaces/SmartLink/Tables';
import { CLIENT_STATUS_TABLE } from '@/interfaces/SmartLink/Equipos';

/**
 * Lista de equipos relacionados por el nombre. Hay varios equipos en una sola fila
 */

export default /*#__PURE__*/_defineComponent({
  __name: 'ResetView',
  setup(__props) {

const store         = useStore();

/********************************
 ************ I18N **************
 *******************************/
const { t } = useI18n();

/********************************
 *********** SERVICES ***********
 *******************************/
const finalData = ref([])

/**
 * HEADER de la tabla, inicia con las columnas obtenidas por RESET_HEADER,
 * luego se realizan "push" dependendo de la cantidad de IPs agregadas
 */
const finalHeader = ref(RESET_HEADER)


/**
 * Cantidad de columnas(x3) a agregar a los HEADERS, dependiendo
 * de la cantidad de equipos que se encuentren en la fila
 */
const maxCountHeader = ref(0)

async function getAllClientStatusData(){
    const allData = await getClientStatusData()
    
    if( allData.status === 400 ){
        store.commit('showSnackBar', {type: LABELS.error, msg: t('snackbar.errorApis'), valor : true});
    }
    if( allData.status === 200 ){
        finalData.value = allData.data.allArrays
        maxCountHeader.value = allData.data.maxCount
    }
}


/**
 * Muestra el dialogo cuando se coloca en TRUE
 */
const dialogValue = ref(false)

/**
 * Lista de las IPs de los equipos obtenidos de una sola fila, al ser seleccionado 
 * para mostrar su información en el diálogo con gráficos 
 */
const finalIPS  = ref<string[]>([])

/**
 * Muestra el dialogo con los gráficos de los equipos. 
 * Además se extrae las IPs de los equipos de cada fila
 * @param item Toda la fila de datos con varios equipos dentro
 */
function showDialog(item:CLIENT_STATUS_TABLE){
     finalIPS.value = Object.entries(item)
    .filter(([key]) => key.startsWith("ip"))
    .map(([, value]) => value)
    dialogValue.value = true;
}

/**
 * Agrega 3 columnas (radio, estado y fecha) por cada equipo agregado del equipo, 
 * todo considerando el valor de maxCountHeader
 */
async function getAllHeaderTable(){
    const head = ref<HEADER[]>([])
    for(let i = 1; i<= maxCountHeader.value; i++){
        head.value.push(
            { text: `Radio #${i}`,           value: `radio${i}`,         sortable: true},
            { text: `Estado #${i}`,          value: `estado${i}`,        sortable: true},
            { text: `Ultima Fecha #${i}`,    value: `fecha${i}`,         sortable: true},
        )
    }
    finalHeader.value = head.value
}


onMounted(async()=>{
   await getAllClientStatusData();
   await getAllHeaderTable()
})


return (_ctx: any,_cache: any) => {
  const _component_v_icon = _resolveComponent("v-icon")!
  const _component_EasyDataTable = _resolveComponent("EasyDataTable")!
  const _component_v_sheet = _resolveComponent("v-sheet")!
  const _component_v_dialog = _resolveComponent("v-dialog")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_v_sheet, {
      color: "transparent",
      class: "containerAreaSheet ma-4"
    }, {
      default: _withCtx(() => [
        (finalData.value.length > 0)
          ? (_openBlock(), _createBlock(_component_EasyDataTable, {
              key: 0,
              "table-class-name": "customize-table",
              "show-index": "",
              headers: finalHeader.value,
              items: finalData.value,
              "rows-per-page": 25,
              onClickRow: showDialog
            }, _createSlots({ _: 2 }, [
              _renderList(maxCountHeader.value, (n) => {
                return {
                  name: `item-estado${n}`,
                  fn: _withCtx((item) => [
                    (item[`ip${n}`])
                      ? (_openBlock(), _createElementBlock("span", _hoisted_1, [
                          _createVNode(_component_v_icon, {
                            color: _unref(getColorStatus)(item[`latencia${n}`])
                          }, {
                            default: _withCtx(() => [
                              _createTextVNode("mdi-circle")
                            ]),
                            _: 2
                          }, 1032, ["color"])
                        ]))
                      : _createCommentVNode("", true)
                  ])
                }
              })
            ]), 1032, ["headers", "items"]))
          : _createCommentVNode("", true)
      ]),
      _: 1
    }),
    _createVNode(_component_v_dialog, {
      modelValue: dialogValue.value,
      "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((dialogValue).value = $event)),
      width: "90%"
    }, {
      default: _withCtx(() => [
        _createVNode(ResetDialog, { finalIPS: finalIPS.value }, null, 8, ["finalIPS"])
      ]),
      _: 1
    }, 8, ["modelValue"])
  ], 64))
}
}

})